import { newsTagListComponent } from "./news-tag-list.component";

export const newsTagList = angular
  .module("components.news-tag.newsTagList", [])
  .component("newsTagList", newsTagListComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("newsTag", {
      parent: "app",
      url: "/home/news-tag/list",
      breadcrumbName: "news Tag",
      parentState: "home",
      component: "newsTagList",
      resolve: {
        details(NewsTagService) {
          "ngInject";
          return NewsTagService.getNewsTagList();
        },
      },
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/news-tag/news-tag-list/news-tag-list.module.js